import { createStyles, makeStyles } from '@material-ui/styles';
import BackgroundPattern from '../../../assets/background/loginLayout/loginBackgroundSpring.svg';

const style = () =>
  createStyles({
    root: {
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '20px',
      backgroundImage: `url(${BackgroundPattern})`,
      backgroundSize: 'cover',
      color: 'white'
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
